import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';

const REQUETE_TELEPHONE = '(max-width: 767px)';

/** Durée par défaut d'un message (ms) ; un message avec bouton Annuler fixe la sienne. */
export const DUREE_MESSAGE_MS = 4000;

/** Sous la barre du haut de la coquille (recherche, aide), pour ne pas la masquer. */
const SOUS_EN_TETE = 'calc(64px + env(safe-area-inset-top))';

/** Vrai sur téléphone : les messages passent au centre, sur toute la largeur utile. */
function useTelephone(): boolean {
  const lire = () => typeof window.matchMedia === 'function' && window.matchMedia(REQUETE_TELEPHONE).matches;
  const [telephone, setTelephone] = useState(lire);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia(REQUETE_TELEPHONE);
    const surChangement = () => setTelephone(media.matches);
    media.addEventListener('change', surChangement);
    return () => media.removeEventListener('change', surChangement);
  }, []);
  return telephone;
}

/**
 * Messages éphémères : en haut, sous la barre de la coquille (à droite sur bureau, au centre sur
 * téléphone). En bas, ils masquaient les boutons « Ajouter à une tournée » des listes et la barre
 * d'onglets ; en haut, ils ne recouvrent que le titre, le temps de leur affichage.
 */
export function Messages() {
  const telephone = useTelephone();
  return (
    <Toaster
      position={telephone ? 'top-center' : 'top-right'}
      duration={DUREE_MESSAGE_MS}
      offset={{ top: SOUS_EN_TETE }}
      mobileOffset={{ top: SOUS_EN_TETE }}
    />
  );
}
